
  Document.prototype.createElementFromString = function (str) {
    const element = new DOMParser().parseFromString(str, "text/html");
    const child = element.documentElement.querySelector("body").firstChild;
    return child;
  };

  window.onload = function () {
    const includesLoadedEvent = new Event("includesLoaded");
    var elements = document.getElementsByTagName("*"),
      i;
    let elementsToLoad = 0;
    let elementsLoaded = 0;
    let isIncluded = false;

    for (i in elements) {
      if (
        elements[i].hasAttribute &&
        elements[i].hasAttribute("include-html")
      ) {
        fragment(elements[i], elements[i].getAttribute("include-html"));
        isIncluded = true;
      }
    }

    const dispatchIncludesLoaded = () => {
      document.querySelector("html")?.dispatchEvent(includesLoadedEvent);
    };

    if (!isIncluded) {
      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", dispatchIncludesLoaded);
      } else {
        dispatchIncludesLoaded();
      }
    }

    function fragment(el, url) {
      elementsToLoad++;
      var localTest = /^(?:file):/,
        xmlhttp = new XMLHttpRequest(),
        status = 0,
        classString = el.getAttribute("class");

      xmlhttp.onreadystatechange = function () {
        if (xmlhttp.readyState == 4) {
          status = xmlhttp.status;
        }
        if (localTest.test(location.href) && xmlhttp.responseText) {
          status = 200;
        }
        if (xmlhttp.readyState == 4 && status == 200) {
          elementsLoaded++;
          var html = document.createElementFromString(xmlhttp.responseText);
          var elements = html.getElementsByTagName("*"),
            i;
          for (i in elements) {
            if (
              elements[i].hasAttribute &&
              elements[i].hasAttribute("include-html")
            ) {
              fragment(elements[i], elements[i].getAttribute("include-html"));
            }
          }
          if (classString) {
            classString
              .split(" ")
              .map((className) => html.classList.add(className));
          }
          el.before(html);
          el.remove();
        }
        if (status === 404) {
          elementsLoaded++;
          el.innerHTML = "Page not found.";
          el.removeAttribute("include-html");
        }

        if (elementsToLoad === elementsLoaded) {
          document.querySelector("html").dispatchEvent(includesLoadedEvent);
        }
      };
      try {
        xmlhttp.open("GET", url, true);
        xmlhttp.send();
      } catch (err) {
        /* todo catch error */
      }
    }
  };
